const quoteStatuses = [
  {
    label: "Pending",
    value: "Pending",
  },
  {
    label: "Won",
    value: "Won",
  },
  {
    label: "Quoted",
    value: "Quoted",
  },
  {
    label: "Lost",
    value: "Loss",
  },
  {
    label: "No Bid",
    value: "NoBid",
  },
  {
    label: "Expired",
    value: "Expired",
  },
];
const quoteStatusesValue = [
  "Pending",
  "Won",
  "Quoted",
  "Loss",
  "NoBid",
  "Expired",
] as const;
export type QuoteStatusesType = (typeof quoteStatusesValue)[number];
export { quoteStatuses, quoteStatusesValue };
